module.exports = __webpack_public_path__ + "img/amsFA4.ac7165a6.png";